"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProtectedNcdWidget = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var NcdInfoSection_1 = require("./NcdInfoSection");
var core_1 = require("@athena-portal/core");
var Types_1 = require("../../../../Types");
var FalconQuestionWidgetBase_1 = require("../../../FalconQuestionWidgetBase");
var InfoQuestionCollapseWrapper_1 = require("../../../../components/infoQuestion/InfoQuestionCollapseWrapper");
var ProtectedNcdWidget = /** @class */ (function (_super) {
    __extends(ProtectedNcdWidget, _super);
    function ProtectedNcdWidget(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            isInfoSectionOpen: false,
            pncdSelected: _this.bindFromField(_this.props.question.interactionField)
        };
        _this.handleOnChangeEvent = _this.handleOnChangeEvent.bind(_this);
        return _this;
    }
    ProtectedNcdWidget.prototype.render = function () {
        var label = (0, jsx_runtime_1.jsx)("span", { children: this.props.question.label });
        return ((0, jsx_runtime_1.jsx)(InfoQuestionCollapseWrapper_1.InfoQuestionCollapseWrapper, { className: "protect-ncd", label: label, info: (0, jsx_runtime_1.jsx)(NcdInfoSection_1.NcdInfoSection, {}), children: this.renderInputField() }));
    };
    ProtectedNcdWidget.prototype.renderInputField = function () {
        return this.renderRadioButtons();
    };
    ProtectedNcdWidget.prototype.handleOnChangeEvent = function (event) {
        var ncdProtected = event.target.value === "true";
        this.setState({ pncdSelected: ncdProtected });
        this.props.onStateChange(this.props.question.interactionField, ncdProtected);
        this.changelogRecorder.recordQuestion("change", this.props);
    };
    ProtectedNcdWidget.prototype.renderRadioButtons = function () {
        return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsxs)("fieldset", { className: "input-group", role: "group", id: this.props.question.name, children: [(0, jsx_runtime_1.jsxs)("div", { className: "custom-control custom-radio", children: [(0, jsx_runtime_1.jsx)("input", { className: "custom-control-input ".concat(this.getInputValidationClass()), type: "radio", name: this.props.question.name, value: "true", checked: this.state.pncdSelected === true, onChange: this.handleOnChangeEvent, id: this.props.question.name + "-true" }), (0, jsx_runtime_1.jsx)("label", { className: "custom-control-label", htmlFor: this.props.question.name + "-true", children: "Yes" })] }), (0, jsx_runtime_1.jsxs)("div", { className: "custom-control custom-radio", children: [(0, jsx_runtime_1.jsx)("input", { className: "custom-control-input ".concat(this.getInputValidationClass()), type: "radio", name: this.props.question.name, value: "false", checked: this.state.pncdSelected === false, onChange: this.handleOnChangeEvent, id: this.props.question.name + "-false" }), (0, jsx_runtime_1.jsx)("label", { className: "custom-control-label", htmlFor: this.props.question.name + "-false", children: "No" })] })] }), this.renderValidationResult()] }));
    };
    __decorate([
        (0, core_1.lazyInject)(Types_1.Types.ChangelogRecorder),
        __metadata("design:type", Object)
    ], ProtectedNcdWidget.prototype, "changelogRecorder", void 0);
    return ProtectedNcdWidget;
}(FalconQuestionWidgetBase_1.FalconQuestionWidgetBase));
exports.ProtectedNcdWidget = ProtectedNcdWidget;
//# sourceMappingURL=ProtectedNcdWidget.js.map